import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const RucFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='RUC' htmlFor='filtro-ruc' xs={4} xl={5} alignRightAt='xs' />
      <Col xs={8} xl={7}>
        <Field name='ruc'>
          {({ field }) => <Form.InputText {...field} id='filtro-ruc' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(RucFormGroup)
